export const robots = [
    {
        id: 1,
        name: 'Zeerak',
        email: 'zeerak@biz.co'
    },
    {
        id: 2,
        name: 'Naseer',
        email: 'naseer@biz.co'
    },
    {
        id: 3,
        name: 'Hassan',
        email: 'hassan@biz.co'
    },
    {
        id: 4,
        name: 'Ali',
        email: 'ali@biz.co'
    },
    {
        id: 5,
        name: 'Knight',
        email: 'knight@biz.co'
    },
    {
        id: 6,
        name: 'Morgan',
        email: 'morgan@biz.co'
    },
    {
        id: 7,
        name: 'Alaan',
        email: 'alaan@biz.co'
    },
    {
        id: 8,
        name: 'Steave',
        email: 'Steave@biz.co'
    },
    {
        id: 9,
        name: 'Alexander',
        email: 'alexander@biz.co'
    },
    {
        id: 10,
        name: 'Micheal',
        email: 'micheal@biz.co'
    }
]